import { useQuery } from '@tanstack/react-query';
import { auditLogApi } from '../api/auditLogApi';
import type { AuditLogSearchCondition } from '../types/auditLog';

/**
 * GET /api/eraf/audit-logs — 전체 감사 로그 목록 (ROLE_ADMIN)
 * queryKey: ['audit-log', 'list', filters]
 */
export function useAuditLogList(filters: AuditLogSearchCondition) {
  return useQuery({
    queryKey: ['audit-log', 'list', filters],
    queryFn: () => auditLogApi.list(filters),
    staleTime: 30_000,
  });
}
